'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './contact-information.component';
import dynamic from 'next/dynamic';

const DynamicContactInformationComponent: ComponentType<Props> = dynamic(
  () => import('./contact-information.component')
);

export default DynamicContactInformationComponent;

export function calculateContactInformationPlaceholderConfig(): PlaceholderConfig {
  return { heightSinceWidth: [{ sinceWidth: 1024, height: 228 }] };
}
